import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const InsuranceIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "InsuranceIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M21.2106 6.19836C21.2024 5.47034 20.6502 4.84867 19.9181 4.7137C19.0224 4.5501 18.1145 4.4274 17.231 4.21472C16.5357 4.04703 15.8445 3.80981 15.1901 3.51943C14.3435 3.14724 13.5255 2.70143 12.7034 2.27199C12.1676 1.98978 11.6523 2.05113 11.1656 2.34561C10.0572 3.01636 8.89976 3.5726 7.66868 3.97341C6.89158 4.2229 6.1104 4.43967 5.2965 4.54192C4.80161 4.60736 4.29446 4.66871 3.82002 4.81595C3.24743 4.99182 2.84659 5.53169 2.83023 6.1411C2.80569 7.05316 2.77706 10.2065 2.78115 10.8732C2.78524 12.3947 3.05518 13.863 3.64413 15.2699C4.0245 16.182 4.55621 17 5.19425 17.7484C5.43147 18.0266 5.6605 18.3129 5.92634 18.5623C6.58074 19.1799 7.29648 19.7198 8.09812 20.1493C9.10016 20.6891 10.0859 21.2576 11.0797 21.8139C11.7014 22.1615 12.3026 22.2024 12.9407 21.8098C13.6237 21.3885 14.3435 21.0163 15.0511 20.6319C15.9181 20.1574 16.7852 19.683 17.546 19.045C18.2413 18.4601 18.8507 17.7934 19.3701 17.045C19.9631 16.1861 20.4376 15.2658 20.7402 14.2638C20.9488 13.5685 21.1288 12.865 21.1738 12.1329C21.1901 11.8425 21.2147 11.548 21.2147 11.2577C21.2147 9.57258 21.2269 7.88752 21.2106 6.20654M17.8895 10.5501V11.9857C17.8895 12.7014 17.5419 13.3722 16.957 13.7812L12.818 16.8323C12.3272 17.1758 11.6768 17.1758 11.186 16.8323L7.05109 13.7812C6.46213 13.3722 6.11449 12.7014 6.11449 11.9857V10.5542C6.1104 10.4846 6.1063 10.411 6.1063 10.3374C6.1063 10.2638 6.1104 10.1943 6.11449 10.1206C6.17584 9.2004 6.62165 8.3824 7.2965 7.83026C7.76685 7.44171 8.34762 7.18813 8.98566 7.11451C9.092 7.10224 9.19833 7.09406 9.30876 7.09815C9.32103 7.09815 9.33329 7.09406 9.34965 7.09406C10.4458 7.09406 11.4151 7.64212 12.004 8.47647C12.5889 7.64212 13.5582 7.09406 14.6544 7.09406C14.6707 7.09406 14.683 7.09815 14.6993 7.09815C14.8057 7.09406 14.9161 7.10224 15.0224 7.11451C15.6564 7.18813 16.2372 7.44171 16.7075 7.83026C17.3823 8.3824 17.8323 9.2004 17.8895 10.1247C17.8936 10.1943 17.8977 10.2679 17.8977 10.3374C17.8977 10.411 17.8936 10.4806 17.8895 10.5501Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default InsuranceIcon;
